"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const ListingOfferListSkeletonItemView_1 = __importDefault(require("@react/web/Listing/ListingOffersList/views/ListingOfferListSkeletonItemView"));
const ListingOffersSkeletonView = () => {
    const skeletonItems = [];
    const skeletonItemsCount = 6;
    for (let i = 0; i < skeletonItemsCount; i++) {
        skeletonItems.push(react_1.default.createElement(ListingOfferListSkeletonItemView_1.default, { key: `listing-skeleton-item-${i}` }));
    }
    return react_1.default.createElement("div", { className: "skeleton-list grid-flex listing" },
        react_1.default.createElement("div", { className: "skeleton content-aside-listing" },
            react_1.default.createElement("div", { className: "skeleton-filter" })),
        react_1.default.createElement("div", { key: 'listing-item-offers-skeleton-list', className: "content-main-listing" },
            react_1.default.createElement("div", { className: "listing-item-offers-list listing-item-offers-skeleton-list linear-listing" }, skeletonItems)));
};
exports.default = ListingOffersSkeletonView;
